<template>
  <component :is="layoutComponent" :body-class="bodyClass" :active-sidebar="activeSidebar">
    <router-view />
  </component>
</template>

<script>
import { CheckSession } from '@/actions/userActions.js'
import { GetApiUrl } from '@/helpers/apiBaseUrl.js'
import { useCookies } from "vue3-cookies"
import 'dotenv/config'
import { Tooltip } from 'bootstrap'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import DeluxeLayout from '@/layouts/DeluxeLayout.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'

export default {
  name: 'App',
  components: {
    DefaultLayout,
    DeluxeLayout,
    BlankLayout
  },
  computed: {
    layoutComponent() {
      if (this.$route.meta.layout === 'blank') {
        return 'BlankLayout'
      }

      return this.$route.meta.layout === 'deluxe' ? 'DeluxeLayout' : 'DefaultLayout'
    },
    bodyClass() {
      const classes = new Set(String(this.$route.meta.bodyClass || '').split(' ').filter(Boolean))

      if (this.$route.path.startsWith('/high-level-estimates')) {
        classes.add('theme-bidding')
      }

      return Array.from(classes).join(' ')
    },
    activeSidebar() {
      return this.$route.meta.activeSidebar || ''
    }
  },
  mounted (){
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  },
  setup(){
    const { cookies } = useCookies()
    if(cookies.get('_auzer')){
      CheckSession().then((res)=>{
        if(!res){
          cookies.set('_redirreq', window.location.pathname ,'15min','/','',true,'Strict')
          cookies.remove('_auzer')
          const boqOrigin = process.env.VUE_APP_BOQ_URL || window.location.origin
          window.location.href = GetApiUrl("/api/auth/sso?origin="+encodeURIComponent(boqOrigin))
        }
      })
    }
  }
}
</script>

<style scoped>
.sticky-top{
  position: sticky;
  top: 0;
}
</style>
